"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const utils_1 = require("../utils");
var QueryActionTypes;
(function (QueryActionTypes) {
    QueryActionTypes["LOADING"] = "LOADING";
    QueryActionTypes["SUCCESS"] = "SUCCESS";
    QueryActionTypes["FAIL"] = "FAIL";
})(QueryActionTypes || (QueryActionTypes = {}));
const queryReducer = (state, action) => {
    switch (action.type) {
        case QueryActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { error: null, loading: true });
        case QueryActionTypes.SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, loading: false });
        case QueryActionTypes.FAIL:
            return Object.assign(Object.assign({}, state), { error: action.error, loading: false });
        default:
            return Object.assign({}, state);
    }
};
const useQuery = (request, key, memberId, siteId, path) => {
    const [store, dispatch] = (0, react_1.useReducer)(queryReducer, {
        loading: false,
        data: undefined,
    });
    (0, react_1.useEffect)(() => {
        const cachedData = (0, utils_1.getCachedData)(key);
        const data = (0, utils_1.isDataOutdated)(cachedData, 10, memberId, siteId, path) ? null : cachedData;
        dispatch({ type: QueryActionTypes.LOADING });
        if (data) {
            dispatch({ payload: data.data, type: QueryActionTypes.SUCCESS });
        }
        else {
            const headers = Object.assign({ credentials: 'same-origin', 'Content-Type': 'application/json' }, (siteId && { 'x-vp-siteid': `${siteId}` }));
            fetch(request, {
                method: 'GET',
                headers,
            })
                .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);
                return response;
            })
                .then(async (response) => {
                const jsonResponse = await response.json();
                return jsonResponse;
            })
                .then((jsonResponse) => {
                if (jsonResponse) {
                    (0, utils_1.setCachedData)(key, jsonResponse, memberId, siteId, path);
                }
                dispatch({ payload: jsonResponse, type: QueryActionTypes.SUCCESS });
            })
                .catch((err) => {
                dispatch({ error: new Error(err.message), type: QueryActionTypes.FAIL });
            });
        }
    }, [request, key, memberId, siteId, path]);
    return Object.assign({}, store);
};
exports.default = useQuery;
